import actionCreatorFactory from "typescript-fsa";

const actionCreator = actionCreatorFactory();

export const GIHSF_LOAD_WITH_PROPS = 'GIHSF_LOAD_WITH_PROPS';
export const gihsfLoadWithProps = actionCreator<{ugId: string}>(GIHSF_LOAD_WITH_PROPS);

export const GIHSF_LOAD_WITHOUT_PROPS = 'GIHSF_LOAD_WITHOUT_PROPS';
export const gihsfLoadWithoutProps = actionCreator(GIHSF_LOAD_WITHOUT_PROPS);
